import { render, staticRenderFns } from "./PublicSocialLoginAppleBusinessConnect.vue?vue&type=template&id=f856e50e"
import script from "./PublicSocialLoginAppleBusinessConnect.vue?vue&type=script&lang=ts"
export * from "./PublicSocialLoginAppleBusinessConnect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports